export default function counter (value, { limit = 100 } = {}) {
  return parseInt(value, 10) >= limit ? `${limit - 1}+` : value;
}
